module.exports = __webpack_public_path__ + "img/personal_data_ad.6a4f9e7b.png";